export default "__VITE_ASSET__CKemoBQU__"